import { styled, Typography } from "@mui/material";
import { tokens } from "@styles/tokens";

/** The Skuey wordmark. `size` is the font size in px (44 mobile, 32 desktop). */
export function Wordmark({ size }: { size: number }) {
  return (
    <Root variant="h1" $size={size}>
      Sku<span>ey</span>
    </Root>
  );
}

const Root = styled(Typography, {
  shouldForwardProp: (p) => p !== "$size",
})<{ $size: number }>(({ theme, $size }) => ({
  fontFamily: tokens.font.family,
  fontWeight: tokens.font.weight.bold,
  fontSize: $size,
  color: theme.skuey.ink,
  "& span": { color: theme.skuey.brand[600] },
}));
